// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import Buefy from 'buefy'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import VueAnalytics from 'vue-analytics'
import fr from 'vee-validate/dist/locale/fr'
import VeeValidate, { Validator } from 'vee-validate'

require('font-awesome/css/font-awesome.css')

Vue.use(Buefy, {
  defaultIconPack: 'fa',
  defaultNoticeQueue: false
})

// Paste your endpoint for the Simple API here.
// Info: https://github.com/graphcool-examples/vue-apollo-instagram-example#2-create-graphql-api-with-graphcool
const httpLink = new HttpLink({
  uri: 'https://api.graph.cool/simple/v1/cj63wpfe4hjmq0160xyp9v449'
})

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

Vue.use(VueApollo)

// Install the vue plugin
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

// Google Analytics
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-99632110-2',
    router,
    autoTracking: {
      exception: true
    }
  })
}

Validator.localize('fr', fr)

Vue.use(VeeValidate, {
  locale: store.state.language.locale.substr(0, 2),
  dictionary: {
    en: {
      attributes: {
        itemName: '"What"',
        itemQuantity: '"Quantity"'
      }
    },
    fr: {
      attributes: {
        itemName: '"Quoi"',
        itemQuantity: '"Quantité"'
      }
    }
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  apolloProvider,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js